import { render, staticRenderFns } from "./ConversationItem.vue?vue&type=template&id=3002b81c&scoped=true&"
import script from "./ConversationItem.vue?vue&type=script&lang=js&"
export * from "./ConversationItem.vue?vue&type=script&lang=js&"
import style0 from "./ConversationItem.vue?vue&type=style&index=0&id=3002b81c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3002b81c",
  null
  
)

export default component.exports